const premiumScripts = () => {
  $('.js-user-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          dots: false,
        },
      },
    ],
  });

  $('input[name="membership_name"]').on('change', function () {
    const membership = $(this).val();
    if (membership) {
      $('.package-detail__price li').hide();
      $(`[data-package="${membership}"]`).show();
    }
  });

  $('.js-toggle-dropdown').on('click', function () {
    if ($(this).siblings('.js-dropdown').hasClass('active')) {
      $('.js-dropdown.active').removeClass('active');
    } else {
      $('.js-dropdown.active').removeClass('active');
      $(this).siblings('.js-dropdown').addClass('active');
    }

    $('.js-dropdown').on('click', function () {
      $(this).removeClass('active');
    });
  });
};

export default premiumScripts;
